import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
/** 扫描模式枚举 */
export enum ScanMode {
  /** 指定终端 */
  specified = 1,
  /** 自动分配 */
  auto = 2
}

/** 扫描状态枚举 */
export enum ScanStatus {
  /** 未扫描 */
  notScanned = 0,
  /** 扫描中 */
  scanning = 1,
  /** 扫描完成 */
  completed = 2,
  /** 扫描失败 */
  fail = 3,
  /** 扫描超时 */
  timeout = 4
}

/** 需要轮询的动态状态 */
export const DYNAMIC_STATUS = [ScanStatus.scanning]

/** 子网发现情况项 */
export interface SubnetStatusItem {
  /** 子网地址 */
  subnet_address: string
  /** 扫描模式（1-指定终端，2-自动分配） */
  scan_mode: number
  /** 已安装终端 */
  installed_clients: number
  /** 未安装终端 */
  uninstalled_clients: number
  /** 扫描状态 0-未扫描，1-扫描中，2-扫描完成，3-扫描失败，4-扫描超时 */
  scan_status: number
  /** 最近扫描时间 */
  last_scan_time: number
  /** 备注 */
  remarks: string
  /** 子网id */
  id: number
}

/** 子网发现情况列表请求 */
export interface SubnetStatusListReq {
  /** 是否升序，默认 false（降序） */
  asc?: boolean
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 扫描状态 0-未扫描，1-扫描中，2-扫描完成，3-扫描失败，4-扫描超时 */
  scan_status?: number
  /** 排序字段，可选值：uninstalled_clients（未安装终端数） */
  sort?: string
  /** 子网地址 */
  subnet_address?: string
}

/** 子网发现情况列表响应 */
export interface SubnetStatusListRes {
  list?: SubnetStatusItem[]
  total?: number
}


@Injectable()
export class SubnetStatusService {
  constructor (private http: Http) {
  }

  /** 获取子网发现情况列表 */
  @ParamsClean()
  getSubnetStatusList (data: SubnetStatusListReq) {
    return this.http.post<SubnetStatusListRes>('/client_find/subnet_list', data)
  }

  /** 导出子网发现情况 */
  download (type: 0 | 1, options: Pick<SubnetStatusListReq, 'subnet_address'> & Partial<Pick<SubnetStatusListReq, 'scan_status'>>, moduleName: string) {
    const params = {
      ...options,
      file_type:type,
      page: 0,
      limit: 0
    }
    return this.http.downloadWithBlob('/client_find/subnet_list_export', params, moduleName)
  }
}

